var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibraryLogo = function SvgLibraryLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1052.27 350.85"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "library logo")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_5085",
    "data-name": "Path 5085",
    className: "cls-1",
    d: "M89.4,261.75h11.8c1.7,0,3.2-1.4,3.2-3.2v-23.8c0-1.6-1.2-2.9-2.7-3.1L3.6,217.55c-1.7-.2-3.3,1-3.6,2.7v23.5c0,1.7,1.4,3.1,3.2,3.1h71.4l-72,14.4C1.1,261.55,0,262.85,0,264.45v54c0,1.8,1.4,3.2,3.2,3.2h.5l98-14.7c1.6-.2,2.7-1.6,2.7-3.1v-24.6c0-.8-.2-1.6-.5-2.3h0c-.3-.7-.8-1.4-1.3-2l-13.2-13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5087",
    "data-name": "Path 5087",
    className: "cls-1",
    d: "M270.3,248.35c-19.9.1-36,16.4-35.9,36.3v.3c-.4,19.8,15.3,36.2,35.1,36.7,19.8.4,36.2-15.3,36.7-35.1v-1.6c.3-19.9-15.6-36.3-35.6-36.6-.1,0-.2,0-.3,0M270.3,312.05c-14.6-.4-26-12.5-25.6-27.1-.8-14.2,10-26.3,24.2-27.1s26.3,10,27.1,24.2v2.9c.5,14.5-11,26.6-25.5,27.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5088",
    "data-name": "Path 5088",
    className: "cls-1",
    d: "M348.7,312.05c-13.2,0-24.9-11.7-24.9-27.1s11.7-27.1,24.9-27.1c8.5.3,16.5,4.6,21.2,11.7l7.3-7.3c-7-8.6-17.5-13.7-28.6-13.9-19.8.5-35.5,16.8-35.2,36.6-.4,19.8,15.4,36.2,35.2,36.6,11.4-.4,22.1-5.8,29.3-14.7l-7.3-6.6c-5.1,7.1-13.2,11.4-21.9,11.8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8524",
    "data-name": "Rectangle 8524",
    className: "cls-1",
    x: 389,
    y: 217.55,
    width: 10.3,
    height: 102.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    className: "cls-1",
    d: "M421.2,222.25c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6h0c0-3.7-2.9-6.6-6.6-6.6h0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8525",
    "data-name": "Rectangle 8525",
    className: "cls-1",
    x: 416.1,
    y: 249.75,
    width: 10.2,
    height: 70.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    className: "cls-1",
    d: "M475.4,248.35c-9.4-.1-18.4,4.2-24.2,11.7v-10.3h-10.2v101.1h10.3v-41c5.8,7.4,14.7,11.8,24.2,11.7,19,0,34.4-15.4,34.4-36.6s-15.4-36.6-34.5-36.6M475.4,312.05c-12.5,0-24.2-11.7-24.2-27.1s11.7-27.1,24.2-27.1c13.2,0,24.2,11,24.2,27.1s-11,27.1-24.2,27.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5091",
    "data-name": "Path 5091",
    className: "cls-1",
    d: "M528.8,268.05c0-5.1,5.1-10.3,13.2-10.3,6,0,11.7,2.7,15.4,7.3l7.3-7.3c-5.9-6.2-14.2-9.6-22.7-9.5-13.9,0-23.4,9.5-23.4,19.8,0,24.2,38.1,16.1,38.1,32.2,0,6.6-5.1,11.7-15.4,11.7-7.4-.4-14.1-4.2-18.3-10.2l-7.3,7.3c6,8,15.6,12.7,25.6,12.4,16.1,0,25.6-9.5,25.6-21.2.1-24.8-38-16.8-38.1-32.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.4,217.55h39.6c16.8,0,28.6,11.7,28.6,26.4,0,8.2-2.9,13.3-5.9,16.7-1.8,1.9-3.7,3.5-5.9,4.5,3.1,1.5,5.9,3.4,8.4,5.7,4.2,4.1,8.5,10.4,8.5,19.9,0,16.8-12.4,29.3-31.5,29.3h-41.8v-102.5h0ZM192.9,260.65c11.1,0,17.6-6.3,17.6-16.7,0-9.5-6.4-16.1-17.6-16.1h-28.6v32.8h28.6ZM195.1,309.85c12.4,0,20.5-7.9,20.5-19s-8.1-20.5-20.5-20.5h-30.8v39.5h30.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.64,168.65V2.05h11.53v155.06h93.55v11.53H1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.63,168.65V2.05h11.53v166.6h-11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.73,97.01c5.55,7.27,8.33,15.51,8.33,24.73,0,5.98-1.33,11.83-3.97,17.56-2.65,5.73-6.45,10.81-11.41,15.25-5.13,4.45-11.15,7.91-18.07,10.38-6.92,2.48-14.23,3.72-21.91,3.72h-61.26l.26-166.6h47.67c15.55,0,27.94,4.36,37.16,13.07,4.27,3.93,7.56,8.46,9.87,13.58s3.46,10.42,3.46,15.89c0,6.84-1.58,13.07-4.74,18.71-3.16,5.64-7.05,10-11.66,13.07l-2.31,1.54c3.24,1.03,6.06,2.05,8.46,3.08,7.86,3.42,14.57,8.76,20.12,16.02ZM224.23,74.59h35.63c4.61,0,8.46-.26,11.53-.77s6.15-1.37,9.23-2.56c4.44-1.88,8.67-5.13,12.69-9.74,4.01-4.61,6.02-10.25,6.02-16.92,0-5.29-1.5-10.29-4.49-14.99-2.99-4.7-7.43-8.5-13.33-11.41-5.9-2.9-12.94-4.36-21.15-4.36h-36.14v60.74ZM296.77,151.99c6.66-3.42,11.79-7.82,15.38-13.2,3.59-5.38,5.38-11.06,5.38-17.04,0-6.66-2.09-12.69-6.28-18.07-4.19-5.38-9.19-9.35-14.99-11.92-8.2-3.59-18.54-5.38-31.01-5.38h-41.01v70.74h49.47c8.71,0,16.4-1.71,23.07-5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.44,168.65l-69.2-84.07h20.5c12.64,0,22.9-1.62,30.76-4.87,5.81-2.73,10.85-6.88,15.12-12.43,4.27-5.55,6.41-11.66,6.41-18.33,0-5.98-1.79-11.66-5.38-17.04-3.59-5.38-8.71-9.78-15.38-13.2-6.66-3.42-14.35-5.13-23.07-5.13h-46.65v155.06h-11.53V2.05h58.18c7.86,0,15.21,1.24,22.04,3.72,6.83,2.48,12.82,6.02,17.94,10.64,4.95,4.45,8.75,9.48,11.41,15.12,2.65,5.64,3.97,11.45,3.97,17.43,0,9.4-2.82,17.81-8.46,25.25-5.64,7.43-12.3,12.78-19.99,16.02-5.3,2.4-10.47,3.89-15.51,4.49-5.04.6-10.38.9-16.02.9l60.23,73.05h-15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.89,126.36l-19.74,42.29h-12.82L616.77,0l74.07,168.65h-12.56l-18.71-42.29h-88.68ZM616.26,28.45l-39.98,86.38h78.17l-38.19-86.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.4,168.65l-69.2-84.07h20.5c12.64,0,22.9-1.62,30.76-4.87,5.81-2.73,10.85-6.88,15.12-12.43,4.27-5.55,6.41-11.66,6.41-18.33,0-5.98-1.79-11.66-5.38-17.04-3.59-5.38-8.71-9.78-15.38-13.2-6.66-3.42-14.35-5.13-23.07-5.13h-46.65v155.06h-11.53V2.05h58.18c7.86,0,15.21,1.24,22.04,3.72,6.83,2.48,12.82,6.02,17.94,10.64,4.95,4.45,8.75,9.48,11.41,15.12,2.65,5.64,3.97,11.45,3.97,17.43,0,9.4-2.82,17.81-8.46,25.25-5.64,7.43-12.3,12.78-19.99,16.02-5.3,2.4-10.47,3.89-15.51,4.49-5.04.6-10.38.9-16.02.9l60.23,73.05h-15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M972.82,98.42L1038.43,2.05h13.84l-73.82,108.93v57.67h-11.53v-57.67L893.1,2.05h13.84l65.87,96.37Z"
  }))))));
};
export default SvgLibraryLogo;